import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { ICompany } from '@leedpulse-monorepo/interfaces';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';

/** The company owning an api key: an orphan Leedflow contact is parked on its company's key (LEED-2463) */
async function getCompanyByApiKey(apiKey: string): Promise<ICompany | null> {
  try {
    const snapCompanies = await getDocs(
      query(collection(firestore, FirestoreCollections.companies), where('api_key', '==', apiKey), limit(1))
    );
    if (snapCompanies.empty) {
      return null;
    }
    return { ...snapCompanies.docs[0].data(), id: snapCompanies.docs[0].id } as ICompany;
  } catch (e) {
    console.log('error: ', e);
    throw new GetCompanyByApiKeyFailure();
  }
}

export class GetCompanyByApiKeyFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getCompanyByApiKey;